<template>
  <router-link
    :to="{name: 'club_info', params: {clubId: clubId}}"
  >
    {{text}}
  </router-link>
</template>

<script>
export default {
  name: 'ClubLink',

  props: {
    clubId: {
      type: Number,
      required: true,
    },

    label: {
      type: String,
      default: 'club'
    },
  },

  computed: {
    /** @returns {string} */
    text() {
      const label = this.label;
      const idStr = this.clubId.toString();

      if(label.length > 0) {
        return label + ' ' + idStr;
      } else {
        return idStr;
      }
    },
  },
};
</script>
